import React, { useEffect, useState } from "react";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTemporaryMenuCartProviderCart } from "../hooks/contexts/TemporaryMenuCartContext";
import { formatMoney } from "../services/strings/formatters";

const CartPillButton = () => {
  const { temporaryMenuCart, fetchTemporaryMenuCart } = useTemporaryMenuCartProviderCart();
  const [quantity, setQuantity] = useState(0);
  const navigate = useNavigate();
  

 useEffect(() => {
  getQuantity();
  }, [temporaryMenuCart]);

  const getQuantity = () => {
    var quantity : number = temporaryMenuCart ? temporaryMenuCart.items.length : 0;
    setQuantity(quantity);
    }
  
    console.log("cart", temporaryMenuCart)
  return (
    <Button
      variant="contained"
      onClick={() => { if (temporaryMenuCart) { navigate("/order/confirm") } } }
      sx={{ background: "#162C1F", border: "1px solid #162C1F", borderRadius: "24px" }}
      style={{
        position: "fixed",
        bottom: "4rem",
        right: "1rem",
        borderRadius: "50px",
        padding: "0.5rem 1.5rem",
        display: "flex",
        alignItems: "center",
        zIndex: 1300,    // anything above your footer’s z-index
      }}
    >
      <ShoppingCartIcon style={{ marginRight: "0.5rem" }} />
      <span>{
        temporaryMenuCart ? 
          `${formatMoney((temporaryMenuCart.grandTotalBeforeFees || 0) / 100)} - ${quantity || 0} items` :
          `Empty`
        }
      
      </span>
    </Button>
  );
};

export default CartPillButton;
